import {Media, MediaData, MediaInterface} from '../Media'

export declare type CommentVariantProp = {
  owner_type: string
  owner_id: number
}

export interface CommentData {
  id: number | null
  allow_comment: boolean
  comment_count: number
  dislike_count: number
  like_count: number
  comment_id: number,
  type_tid: string
  owner_type: string,
  owner_id: number,
  voice_count: number
  voice_sum: number
  voice_average: number
  header: string | null
  message: string
  email: string | null
  avatar: MediaData | null
  name: string
  created_at: string | null
  published_at: string | null
  updated_at: string | null
}

export interface CommentInterface {
  id(): number | null

  header(): string | null

  message(): string

  email(): string | null

  avatar(): MediaInterface | null

  name(): string

  commentId(): number | null

  createdAt(): Date | null

  publishedAt(): Date | null

  updatedAt(): Date | null

  countDislikes(): number

  countLikes(): number

  countComments(): number

  countVoices(): number

  sumVoices(): number

  averageVoices(): number

  setVoicesMetric(count: number, sum: number, average: number): void
}

export default class Comment implements CommentInterface {

  private readonly data: CommentData
  private readonly _avatar: Media | null
  private readonly _publishedAt: Date | null
  private readonly _updatedAt: Date | null
  private readonly _createdAt: Date | null

  public constructor(data: CommentData) {
    this.data = data
    this._avatar = data.avatar ? new Media(data.avatar as MediaData) : null;
    this._publishedAt = data.published_at ? new Date(data.published_at) : null
    this._updatedAt = data.updated_at ? new Date(data.updated_at) : null
    this._createdAt = data.created_at ? new Date(data.created_at) : null
  }

  public id(): number | null {
    return this.data.id
  }

  public header(): string | null {
    return this.data.header
  }

  public message(): string {
    return this.data.message
  }

  public email(): string | null {
    return this.data.email
  }

  public avatar(): MediaInterface | null {
    return this._avatar
  }

  public name(): string {
    return this.data.name
  }

  public commentId(): number | null {
    return this.data.comment_id
  }

  public createdAt(): Date | null {
    return this._createdAt
  }

  public publishedAt(): Date | null {
    return this._publishedAt
  }

  public updatedAt(): Date | null {
    return this._updatedAt
  }

  public countDislikes(): number {
    return this.data.dislike_count
  }

  public countLikes(): number {
    return this.data.like_count
  }

  public countComments(): number {
    return this.data.comment_count
  }

  public countVoices(): number {
    return this.data.voice_count
  }

  public sumVoices(): number {
    return this.data.voice_sum
  }

  public averageVoices(): number {
    return this.data.voice_average
  }

  public setVoicesMetric(count: number, sum: number, average: number): void {
    this.data.voice_count = count
    this.data.voice_sum = sum
    this.data.voice_average = average
  }
}

export const commentEmptyData: CommentData = {
  id: null,
  allow_comment: true,
  comment_count: 0,
  dislike_count: 0,
  like_count: 0,
  comment_id: 0,
  type_tid: '',
  owner_type: '',
  owner_id: 0,
  voice_count: 0,
  voice_sum: 0,
  voice_average: 0,
  header: null,
  message: '',
  email: null,
  avatar: null,
  name: '',
  created_at: (new Date()).toISOString(),
  published_at: null,
  updated_at: null
}
